import { render } from "./ContSectionright.vue?vue&type=template&id=4420385c&scoped=true"
import script from "./ContSectionright.vue?vue&type=script&lang=js"
export * from "./ContSectionright.vue?vue&type=script&lang=js"

import "./ContSectionright.vue?vue&type=style&index=0&id=4420385c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4420385c"]])

export default __exports__